import { differenceInSeconds } from 'date-fns'


export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match('rgba')) {
    const triplet = hex.slice(5).split(',').slice(0, -1).join(',')
    return triplet
  }

  let c

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }

    c = `0x${c.join('')}`

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')
  }
}

export function debounce(func, wait, immediate) {
  let timeout
  return function () {
    const context = this,
      args = arguments
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      timeout = null

      if (!immediate) {func.apply(context, args)}
    }, wait)

    if (immediate && !timeout) {func.apply(context, args)}
  }
}

export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches
  }

  return false
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches
  }

  return false
}

function currentYPosition(elm) {
  if (!window && !elm) {
    return
  }

  if (elm) {return elm.scrollTop}

  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) {return window.pageYOffset}

  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop) {return document.documentElement.scrollTop}

  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) {return document.body.scrollTop}

  return 0
}

function elmYPosition(elm) {
  let y = elm.offsetTop
  let node = elm

  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent
    y += node.offsetTop
  }

  return y
}

export function scrollTo(scrollableElement, elmID) {
  const elm = document.getElementById(elmID)

  if (!elmID || !elm) {
    return
  }

  const startY = currentYPosition(scrollableElement)
  const stopY = elmYPosition(elm)

  const distance = stopY > startY ? stopY - startY : startY - stopY

  if (distance < 100) {
    scrollTo(0, stopY)
    return
  }

  let speed = Math.round(distance / 50)

  if (speed >= 20) {speed = 20}

  const step = Math.round(distance / 25)
  let leapY = stopY > startY ? startY + step : startY - step
  let timer = 0

  if (stopY > startY) {
    for (let i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY)
          }
        })(leapY),
        timer * speed
      )
      leapY += step

      if (leapY > stopY) {leapY = stopY}

      timer++
    }

    return
  }

  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY)
        }
      })(leapY),
      timer * speed
    )
    leapY -= step

    if (leapY < stopY) {leapY = stopY}

    timer++
  }

  return false
}

export function getTimeDifference(date) {
  const difference = differenceInSeconds(new Date(), date)

  if (difference < 60) {return `${Math.floor(difference)} sec`} else if (difference < 3600) {return `${Math.floor(difference / 60)} min`} else if (difference < 86400) {return `${Math.floor(difference / 3660)} h`} else if (difference < 86400 * 30) {return `${Math.floor(difference / 86400)} d`} else if (difference < 86400 * 30 * 12) {return `${Math.floor(difference / 86400 / 30)} mon`}

  return `${(difference / 86400 / 30 / 12).toFixed(1)} y`
}

export function generateRandomId() {
  const tempId = Math.random().toString()
  const uid = tempId.substr(2, tempId.length - 1)
  return uid
}

export function generateRandomString() {
  return (Math.random() + 1).toString(36).substring(7);
}

export function getQueryParam(prop) {
  const params = {}
  const search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf('?') + 1)
  )
  const definitions = search.split('&')
  definitions.forEach((val, key) => {
    const parts = val.split('=', 2)
    params[parts[0]] = parts[1]
  })
  return prop && prop in params ? params[prop] : params
}

export function classList(classes) {
  return Object.entries(classes)
    .filter((entry) => entry[1])
    .map((entry) => entry[0])
    .join(' ')
}

export const discount_unit = {
  'eachn_perc': '%',
  'by_percent': '%',
  'by_fixed': '$',
  'cart_fixed': '$',
  'thecheapest': '%',
  'themostexpencive': '%',
  'buyxgetn_perc': '%',
  'buyxgetn_fixdisc': '$',
  'buyxgetn_fixprice': '$',
  'eachn_fixdisc': '$',
  'eachn_fixprice': '$',
  'groupn_disc': '%',
  'groupn': '$',
  'free_shipping_combined': '$'
};

export const promoRuleType = {

  'fixed_points': 'fixed X points to Customers',
  'price': 'Give X points for every Y amount of Price',
  'fixed_discount':'Give a fixed discount to Customer',
  'percent_discount':'Give percent discount to Customer',
}

export const promoFieldName = {
    'by_percent': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):',
      'nQtyY': 'Number of Y Products:'
    },
    'by_fixed': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
    'cart_fixed': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
    'thecheapest': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
    'themostexpencive': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
    'buyxgetn_perc': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Number of X Products:',
      'nQtyY': 'Number of Y Products:'
    },
    'buyxgetn_fixdisc': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Number of X Products:',
      'nQtyY': 'Number of Y Products:'
    },
    'buyxgetn_fixprice': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Number of X Products:',
      'nQtyY': 'Number of Y Products:'
    },
    'eachn_perc': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Number of X Products:'
    },
    'eachn_fixdisc': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Each N-th:'
    },
    'eachn_fixprice': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Each N-th:'
    },
    'groupn': {
      'discountAmount': 'Discount Amount (in $):',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
    'groupn_disc': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Max Number of Sets Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
    'eachmaftn_perc': {
      'discountAmount': 'Discount Amount (in %):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'eachm': 'After N:',
      'minQtyForDiscount': 'Each Product (step):'
    },
    'eachmaftn_fixdisc': {
      'discountAmount': 'Discount Amount:',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'eachm': 'After N:',
      'minQtyForDiscount': 'Each Product (step):'
    },
    'eachmaftn_fixprice': {
      'discountAmount': 'Discount Amount:',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'maxDiscount': 'Max Amount of Discount:',
      'eachm': 'After N:',
      'minQtyForDiscount': 'Each Product (step):'
    },
    'free_shipping_combined': {
      'discountAmount': 'Discount Amount (in $):',
      'maxQtyForDiscount': 'Maximum Qty Discount is Applied To:',
      'minQtyForDiscount': 'Discount Qty Step (Buy X):'
    },
  };

export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.readAsBinaryString(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export const getFileHeader = (file) => {
  return new Promise(resolve => {
    const headerBytes = file.slice(0, 4); // Read the first 4 bytes of the file
    const fileReader = new FileReader();
    fileReader.onloadend = (e) => {
      // @ts-ignore
      const arr = new Uint8Array(e?.target?.result).subarray(0,4,);
      let header = '';
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }
      resolve(header);
    };
    fileReader.readAsArrayBuffer(headerBytes);
  });
};

export const getMimeType = async (file) => {
  const header = await getFileHeader(file);
  let type;

  //https://en.wikipedia.org/wiki/List_of_file_signatures
  switch (header) {
    case "89504e47":
        type = "image/png";
        break;
    case "47494638":
        type = "image/gif";
        break;
    case "0a0d0d0a":
      type = "image/apng";
      break;
    case "00000100":
    case "0010":
      type = file.type;
      break;
    case '00000200':
      type = "image/vnd.microsoft.icon";
      break;
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
        type = "image/jpeg";
        break;
    default:
        type = "Unknown";
        break;
  }

  return type;
}